module.exports = __webpack_public_path__ + "img/adv_perm.71ce7576.png";